import '@fpsm/cxy-tokens/tokens.css';

import { type FunctionComponent } from 'react';
import { useSuspenseQuery } from '@tanstack/react-query';

import { type FaqProps } from '../contract';

import { type FaqResponseData, fetchFaqData, getFaqCacheKey } from './api/cx-api.service';
import { FaqItem } from './components/FaqItem';
import { list } from './Faq.style';

const FPSM_THEME: Record<string, string> = {
  OC: 'oddschecker',
};

export const Faq: FunctionComponent<FaqProps> = ({ dataApiEndpoint, i18n: _i18n, ...requestParams }) => {
  const { data } = useSuspenseQuery<FaqResponseData | null>({
    queryFn: () => fetchFaqData(dataApiEndpoint, requestParams, { logger: console }),
    queryKey: getFaqCacheKey(requestParams),
  });

  if (!data?.faqs?.length) return null;

  const fpsmTheme = FPSM_THEME[requestParams.repub] ?? 'oddschecker';
  const initiallyOpen = data.displayState === 'expanded';

  return (
    <section data-fpsm-theme={fpsmTheme} data-testid="faq">
      <ul className={list}>
        {data.faqs.map(faq => (
          <li key={faq.id}>
            <FaqItem {...faq} initiallyOpen={initiallyOpen} />
          </li>
        ))}
      </ul>
    </section>
  );
};
